import axios from "axios";

const BASE_URL =
  "https://psetajdse8.execute-api.ap-south-1.amazonaws.com/default";

export const reportsClient = axios.create({
  baseURL: BASE_URL,
});

export const fetchReports = async (user_id) => {
  try {
    const response = await reportsClient.post("/getMarketReports", {
      user_id: user_id,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching reports:", error);
    throw error;
  }
};
